import { Badge } from '@travellegacy/nexops-design-system';
import { STATUS_LABELS, type IncidentStatus } from '../types';
import type { Incident } from '../types';

interface IncidentStatusBadgeProps {
  incident: Incident;
}

const getStatusVariant = (status: IncidentStatus): 'success' | 'default' | 'warning' | 'error' => {
  switch (status) {
    case 'APPROVED':
    case 'CLOSED':
    case 'COMPLETED':
      return 'success';
    case 'MONITORING':
    case 'PENDING_SIGNATURE':
      return 'warning';
    case 'PENDING_APPROVAL':
      return 'default';
    case 'CANCELLED':
      return 'error';
    default:
      return 'default';
  }
};

/**
 * Componente reutilizável para exibir o status de um incidente
 *
 * Exibe o status atual do incidente baseado no campo status.
 * Não exibe badge se o status for APPROVED (aprovado mas sem ações pendentes).
 */
export function IncidentStatusBadge({ incident }: IncidentStatusBadgeProps) {
  // Não exibe badge se está apenas aprovado (sem pendências ou ações)
  if (incident.status === 'APPROVED') {
    return null;
  }

  // Exibe o status atual do incidente
  return (
    <Badge variant={getStatusVariant(incident.status)}>
      {STATUS_LABELS[incident.status]}
    </Badge>
  );
}
